// extracted by mini-css-extract-plugin
module.exports = {"spinner-container":"ContactPage_spinner-container__Pl9zC","spinner":"ContactPage_spinner__1keTp","alphachat-container":"ContactPage_alphachat-container__DSYAk"};